export default __webpack_public_path__ + "static/media/home_cookies_second.d5bcb3aa.jpg";